export default {
    tasksStatus: {
        onTrack: null,
        attention: null,
        atRisk: null,
        overdue: null,
        total: null
    },
    tasksOverview: [],
    tasksList: null,
    active: false,
    taskForTeam: [],
    removeRouteQuery: false
};
